var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "full-width q-pb-md" },
    [
      _c(
        "q-tabs",
        {
          staticClass: "full-width",
          model: {
            value: _vm.event_tab,
            callback: function($$v) {
              _vm.event_tab = $$v
            },
            expression: "event_tab"
          }
        },
        [
          _vm._l(_vm.event_dates, function(event, index) {
            return _c("q-tab", {
              key: "t" + index,
              attrs: {
                slot: "title",
                name: "" + index,
                label: _vm.fDateTime(event.hr_start)
              },
              slot: "title"
            })
          }),
          _vm._l(_vm.event_dates, function(event, index) {
            return _c(
              "q-tab-pane",
              { key: "tp" + index, attrs: { name: "" + index } },
              [
                (_vm.event_dates.length &&
                  event.event_date_type === 1 &&
                  event.has_test !== 3) ||
                (_vm.event_dates.length &&
                  event.event_date_type === 1 &&
                  event.has_test === 3 &&
                  !event.tests.length)
                  ? _c(
                      "q-card",
                      { staticClass: "bg-grey-1 q-mt-xs q-mx-md q-mb-md" },
                      [
                        _c(
                          "q-card-main",
                          { staticClass: "relative-position" },
                          [
                            _c("div", {
                              staticClass: "line-card bg-primary absolute-top"
                            }),
                            _c(
                              "div",
                              { staticClass: "row gutter-xs q-pl-md" },
                              [
                                _c("div", { staticClass: "col-12" }, [
                                  _c(
                                    "p",
                                    {
                                      staticClass: "q-my-xs text-weight-bolder"
                                    },
                                    [_vm._v(_vm._s(_vm.$t("presential_event")))]
                                  )
                                ]),
                                _c(
                                  "div",
                                  { staticClass: "col-12" },
                                  [
                                    _c(
                                      "p",
                                      {
                                        staticClass: "q-my-xs text-weight-bold"
                                      },
                                      [_vm._v(_vm._s(_vm.$t("instructors")))]
                                    ),
                                    _vm._l(
                                      _vm.course.instructors_list,
                                      function(instructor, index) {
                                        return _c(
                                          "div",
                                          {
                                            key: index,
                                            staticClass: "q-my-sm"
                                          },
                                          [
                                            _c(
                                              "p",
                                              { staticClass: "q-my-xs" },
                                              [_vm._v(_vm._s(instructor.name))]
                                            )
                                          ]
                                        )
                                      }
                                    )
                                  ],
                                  2
                                ),
                                _c("div", { staticClass: "col-12" }, [
                                  _c(
                                    "p",
                                    { staticClass: "q-my-xs text-weight-bold" },
                                    [_vm._v(_vm._s(_vm.$t("event_date")))]
                                  ),
                                  _c("div", { staticClass: "col-4" }, [
                                    _c("span", [
                                      _vm._v(
                                        _vm._s(_vm.$t("start_hour")) + ": "
                                      )
                                    ]),
                                    _c("span", [
                                      _vm._v(
                                        _vm._s(_vm.fDateTime(event.hr_start)) +
                                          "H"
                                      )
                                    ])
                                  ]),
                                  _c("div", [
                                    _c("span", [
                                      _vm._v(_vm._s(_vm.$t("end_hour")) + ": ")
                                    ]),
                                    _c("span", [
                                      _vm._v(
                                        _vm._s(_vm.fDateTime(event.hr_end)) +
                                          "H"
                                      )
                                    ])
                                  ])
                                ]),
                                _c("div", { staticClass: "col-12 q-my-xs" }, [
                                  _c(
                                    "p",
                                    { staticClass: "q-my-xs text-weight-bold" },
                                    [_vm._v(_vm._s(_vm.$t("address")))]
                                  ),
                                  _c("div", [
                                    _c("span", { staticClass: "text-body2" }, [
                                      _vm._v(
                                        _vm._s(_vm.address.address) +
                                          ", " +
                                          _vm._s(_vm.address.number) +
                                          " - " +
                                          _vm._s(_vm.address.neighborhood)
                                      )
                                    ])
                                  ]),
                                  _c("div", [
                                    _c("span", { staticClass: "text-body2" }, [
                                      _vm._v(
                                        _vm._s(_vm.address.city) +
                                          " - " +
                                          _vm._s(_vm.address.state)
                                      )
                                    ])
                                  ])
                                ])
                              ]
                            )
                          ]
                        )
                      ],
                      1
                    )
                  : _vm._e(),
                _vm.event_dates.length &&
                event.activities.length !== 0 &&
                event.event_date_type === 1 &&
                _vm.$q.platform.is.desktop
                  ? _c(
                      "q-card",
                      { staticClass: "bg-grey-1 q-mt-xs q-mx-md q-mb-md" },
                      [
                        _c(
                          "q-card-main",
                          { staticClass: "relative-position" },
                          [
                            _c("div", {
                              staticClass: "line-card bg-primary absolute-top"
                            }),
                            _vm.event_dates.length &&
                            event.event_date_type === 1
                              ? _c(
                                  "div",
                                  { staticClass: "row gutter-xs q-pl-md" },
                                  [
                                    _c("div", { staticClass: "col-12" }, [
                                      _c(
                                        "p",
                                        {
                                          staticClass:
                                            "q-my-xs text-weight-bolder"
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(_vm.$t("presential_event"))
                                          )
                                        ]
                                      )
                                    ]),
                                    _c("div", { staticClass: "col-12" }, [
                                      _c(
                                        "p",
                                        {
                                          staticClass:
                                            "q-my-xs text-weight-bold"
                                        },
                                        [_vm._v(_vm._s(_vm.$t("instructor")))]
                                      ),
                                      _c("p", { staticClass: "q-my-xs" }, [
                                        _vm._v(
                                          _vm._s(
                                            _vm.course.instructor_full_name
                                          ) +
                                            " - " +
                                            _vm._s(_vm.course.instructor_email)
                                        )
                                      ])
                                    ]),
                                    _c("div", { staticClass: "col-12" }, [
                                      _c(
                                        "p",
                                        {
                                          staticClass:
                                            "q-my-xs text-weight-bold"
                                        },
                                        [_vm._v(_vm._s(_vm.$t("event_date")))]
                                      ),
                                      _c("div", { staticClass: "col-4" }, [
                                        _c("span", [
                                          _vm._v(
                                            _vm._s(_vm.$t("start_hour")) + ": "
                                          )
                                        ]),
                                        _c("span", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.fDateTime(event.hr_start)
                                            ) + "H"
                                          )
                                        ])
                                      ]),
                                      _c("div", [
                                        _c("span", [
                                          _vm._v(
                                            _vm._s(_vm.$t("end_hour")) + ": "
                                          )
                                        ]),
                                        _c("span", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.fDateTime(event.hr_end)
                                            ) + "H"
                                          )
                                        ])
                                      ])
                                    ]),
                                    _c(
                                      "div",
                                      { staticClass: "col-12 q-mt-xs q-mb-md" },
                                      [
                                        _c(
                                          "p",
                                          {
                                            staticClass:
                                              "q-my-xs text-weight-bold"
                                          },
                                          [_vm._v(_vm._s(_vm.$t("address")))]
                                        ),
                                        _c("div", [
                                          _c(
                                            "span",
                                            { staticClass: "text-body1" },
                                            [
                                              _vm._v(
                                                _vm._s(_vm.address.address) +
                                                  ", " +
                                                  _vm._s(_vm.address.number) +
                                                  " - " +
                                                  _vm._s(
                                                    _vm.address.neighborhood
                                                  )
                                              )
                                            ]
                                          )
                                        ]),
                                        _c("div", [
                                          _c(
                                            "span",
                                            { staticClass: "text-body1" },
                                            [
                                              _vm._v(
                                                _vm._s(_vm.address.city) +
                                                  " - " +
                                                  _vm._s(_vm.address.state)
                                              )
                                            ]
                                          )
                                        ])
                                      ]
                                    )
                                  ]
                                )
                              : _vm._e()
                          ]
                        )
                      ],
                      1
                    )
                  : _vm._e(),
                _vm.event_dates.length &&
                event.activities.length !== 0 &&
                _vm.$q.platform.is.desktop
                  ? _c("q-table", {
                      ref: "table",
                      refInFor: true,
                      staticClass: "shadow-0",
                      attrs: {
                        pagination: _vm.server_pagination,
                        data: _vm.event_dates[_vm.event_tab].activities,
                        columns: _vm.columns,
                        loading: _vm.loading,
                        "row-key": "id",
                        "no-data-label": _vm.$t("no_data_avaliable"),
                        "no-results-label": _vm.$t("no_results_found"),
                        "loading-label": _vm.$t("loading_data"),
                        "rows-per-page-label": _vm.$t("items_per_page"),
                        "rows-per-page-options": [0],
                        "hide-bottom": ""
                      },
                      on: {
                        "update:pagination": function($event) {
                          _vm.server_pagination = $event
                        }
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "header",
                            fn: function(props) {
                              return _c(
                                "q-tr",
                                { attrs: { props: props } },
                                _vm._l(props.cols, function(col) {
                                  return _c(
                                    "q-th",
                                    { key: col.name, attrs: { props: props } },
                                    [
                                      _vm._v(
                                        "\n                    " +
                                          _vm._s(_vm.$t(col.label)) +
                                          "\n                    "
                                      )
                                    ]
                                  )
                                }),
                                1
                              )
                            }
                          },
                          {
                            key: "body",
                            fn: function(props) {
                              return [
                                _c(
                                  "q-tr",
                                  {
                                    class: _vm.getRowClass(props.row),
                                    attrs: { props: props },
                                    nativeOn: {
                                      click: function($event) {
                                        return _vm.showModal(props.row)
                                      }
                                    }
                                  },
                                  [
                                    _c(
                                      "q-td",
                                      {
                                        key: "type_title",
                                        attrs: { props: props }
                                      },
                                      [
                                        _vm._v(
                                          "\n                            " +
                                            _vm._s(props.row.type_title) +
                                            "\n                        "
                                        )
                                      ]
                                    ),
                                    _c(
                                      "q-td",
                                      {
                                        key: "type_slug",
                                        attrs: { props: props }
                                      },
                                      [
                                        _c("q-icon", {
                                          staticClass: "q-mr-sm",
                                          attrs: {
                                            name: _vm.getIcon(
                                              props.row.type_slug
                                            ),
                                            size: "1rem"
                                          }
                                        }),
                                        _vm._v(
                                          "\n                            " +
                                            _vm._s(
                                              _vm.$t(
                                                _vm.getType(props.row.type_slug)
                                              )
                                            ) +
                                            "\n                        "
                                        )
                                      ],
                                      1
                                    ),
                                    _c(
                                      "q-td",
                                      {
                                        key: "avaliable_in",
                                        attrs: { props: props }
                                      },
                                      [
                                        _vm._v(
                                          "\n                            " +
                                            _vm._s(
                                              _vm.fDate(props.row.avaliable_in)
                                            ) +
                                            "\n                        "
                                        )
                                      ]
                                    ),
                                    _c(
                                      "q-td",
                                      { key: "score", attrs: { props: props } },
                                      [
                                        _vm._v(
                                          "\n                            " +
                                            _vm._s(
                                              props.row.score > 0
                                                ? props.row.score
                                                : ""
                                            ) +
                                            "\n                        "
                                        )
                                      ]
                                    ),
                                    _c(
                                      "q-td",
                                      {
                                        key: "user_watch",
                                        attrs: {
                                          props: props,
                                          "auto-width": ""
                                        }
                                      },
                                      [
                                        props.row.is_blocked
                                          ? _c("q-icon", {
                                              attrs: {
                                                name: "fal fa-ban",
                                                size: "1.5rem",
                                                color: "negative"
                                              }
                                            })
                                          : props.row.is_expired
                                          ? _c("q-icon", {
                                              attrs: {
                                                name: "fal fa-clock",
                                                size: "1.5rem",
                                                color: "negative"
                                              }
                                            })
                                          : props.row.user_watch ||
                                            props.row.is_approved
                                          ? _c("q-icon", {
                                              attrs: {
                                                name: "fal fa-check-circle",
                                                size: "1.5rem",
                                                color: "positive"
                                              }
                                            })
                                          : _c("q-icon", {
                                              attrs: {
                                                name: "fal fa-circle",
                                                size: "1.5rem",
                                                color: "primary"
                                              }
                                            })
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              ]
                            }
                          }
                        ],
                        null,
                        true
                      )
                    })
                  : _vm._e()
              ],
              1
            )
          })
        ],
        2
      ),
      _vm.event_dates.length &&
      _vm.event_dates[_vm.event_tab].activities !== undefined &&
      _vm.event_dates[_vm.event_tab].activities.length !== 0 &&
      _vm.$q.platform.is.mobile
        ? _c(
            "div",
            [
              _vm.event_dates.length &&
              _vm.event_dates[_vm.event_tab].event_date_type !== undefined &&
              _vm.event_dates[_vm.event_tab].event_date_type === 1 &&
              _vm.$q.platform.is.mobile
                ? _c(
                    "q-card",
                    { staticClass: "bg-grey-1 q-mt-xs q-mx-md q-mb-md" },
                    [
                      _c("q-card-main", { staticClass: "relative-position" }, [
                        _c("div", {
                          staticClass: "line-card bg-primary absolute-top"
                        }),
                        _c("div", { staticClass: "row gutter-xs q-pl-md" }, [
                          _c("div", { staticClass: "col-12" }, [
                            _c(
                              "p",
                              { staticClass: "q-my-xs text-weight-bolder" },
                              [_vm._v(_vm._s(_vm.$t("presential_event")))]
                            )
                          ]),
                          _c("div", { staticClass: "col-12" }, [
                            _c(
                              "p",
                              { staticClass: "q-my-xs text-weight-bold" },
                              [_vm._v(_vm._s(_vm.$t("instructor")))]
                            ),
                            _c("p", { staticClass: "q-my-xs" }, [
                              _vm._v(
                                _vm._s(_vm.course.instructor_full_name) +
                                  " - " +
                                  _vm._s(_vm.course.instructor_email)
                              )
                            ])
                          ]),
                          _c("div", { staticClass: "col-12" }, [
                            _c(
                              "p",
                              { staticClass: "q-my-xs text-weight-bold" },
                              [_vm._v(_vm._s(_vm.$t("event_date")))]
                            ),
                            _c("div", { staticClass: "col-4" }, [
                              _c("span", [
                                _vm._v(_vm._s(_vm.$t("start_hour")) + ": ")
                              ]),
                              _c("span", [
                                _vm._v(
                                  _vm._s(
                                    _vm.fDateTime(
                                      _vm.event_dates[_vm.event_tab].hr_start
                                    )
                                  ) + "H"
                                )
                              ])
                            ]),
                            _c("div", [
                              _c("span", [
                                _vm._v(_vm._s(_vm.$t("end_hour")) + ": ")
                              ]),
                              _c("span", [
                                _vm._v(
                                  _vm._s(
                                    _vm.fDateTime(
                                      _vm.event_dates[_vm.event_tab].hr_end
                                    )
                                  ) + "H"
                                )
                              ])
                            ])
                          ]),
                          _c("div", { staticClass: "col-12 q-mt-xs q-mb-md" }, [
                            _c(
                              "p",
                              { staticClass: "q-my-xs text-weight-bold" },
                              [_vm._v(_vm._s(_vm.$t("address")))]
                            ),
                            _c("div", [
                              _c("span", { staticClass: "text-body1" }, [
                                _vm._v(
                                  _vm._s(_vm.address.address) +
                                    ", " +
                                    _vm._s(_vm.address.number) +
                                    " - " +
                                    _vm._s(_vm.address.neighborhood)
                                )
                              ])
                            ]),
                            _c("div", [
                              _c("span", { staticClass: "text-body1" }, [
                                _vm._v(
                                  _vm._s(_vm.address.city) +
                                    " - " +
                                    _vm._s(_vm.address.state)
                                )
                              ])
                            ])
                          ])
                        ])
                      ])
                    ],
                    1
                  )
                : _vm._e(),
              _vm._l(_vm.event_dates[_vm.event_tab].activities, function(
                activity,
                index
              ) {
                return _c(
                  "q-card",
                  {
                    key: index,
                    staticClass: "bg-grey-1 q-mt-md",
                    class: _vm.getRowClass(activity)
                  },
                  [
                    _c(
                      "q-card-main",
                      {
                        staticClass: "relative-position",
                        nativeOn: {
                          click: function($event) {
                            return _vm.showModal(activity)
                          }
                        }
                      },
                      [
                        _c("div", {
                          staticClass: "line-card bg-primary absolute-top"
                        }),
                        _c(
                          "div",
                          { staticClass: "row gutter-sm vertical-middle" },
                          [
                            _c("div", { staticClass: "col-9" }, [
                              _c(
                                "p",
                                [
                                  activity.is_blocked
                                    ? _c("q-icon", {
                                        attrs: {
                                          name: "fal fa-ban",
                                          size: "1rem",
                                          color: "negative"
                                        }
                                      })
                                    : activity.user_watch ||
                                      activity.is_approved
                                    ? _c("q-icon", {
                                        attrs: {
                                          name: "fal fa-check-circle",
                                          size: "1rem",
                                          color: "positive"
                                        }
                                      })
                                    : _c("q-icon", {
                                        attrs: {
                                          name: "fal fa-circle",
                                          size: "1rem",
                                          color: "primary"
                                        }
                                      }),
                                  _c(
                                    "span",
                                    { staticClass: "q-ml-sm q-subheading" },
                                    [_vm._v(_vm._s(activity.type_title))]
                                  )
                                ],
                                1
                              ),
                              activity.avaliable_in
                                ? _c("div", [
                                    _c("p", { staticClass: "q-caption" }, [
                                      _vm._v(
                                        _vm._s(_vm.$t("avaliable_in")) +
                                          " " +
                                          _vm._s(
                                            _vm.fDate(activity.avaliable_in)
                                          )
                                      )
                                    ])
                                  ])
                                : _vm._e()
                            ]),
                            _c(
                              "div",
                              { staticClass: "col-3 text-right" },
                              [
                                _c("q-icon", {
                                  attrs: {
                                    name: _vm.getIcon(activity.type_slug),
                                    size: "3rem",
                                    color: "secondary"
                                  }
                                })
                              ],
                              1
                            )
                          ]
                        )
                      ]
                    ),
                    _vm.$q.platform.is.android
                      ? _c("q-card-separator")
                      : _vm._e()
                  ],
                  1
                )
              })
            ],
            2
          )
        : _vm._e(),
      _vm.event_dates.length &&
      _vm.event_dates[_vm.event_tab].activities.length == 0 &&
      _vm.event_dates[_vm.event_tab].event_date_type !== 1
        ? _c(
            "q-card",
            { staticClass: "bg-grey-1 cursor-pointer" },
            [
              _c("q-card-main", { staticClass: "relative-position" }, [
                _c("div", { staticClass: "line-card bg-primary absolute-top" }),
                _c("div", { staticClass: "row gutter-sm" }, [
                  _c("div", { staticClass: "col-12" }, [
                    _c("p", { staticClass: "q-subheading" }, [
                      _vm._v(_vm._s(_vm.$t("no_items_found")))
                    ])
                  ])
                ])
              ])
            ],
            1
          )
        : _vm._e(),
      _c(
        "q-modal",
        {
          attrs: {
            "content-css": { minWidth: "100vw", minHeight: "100vh" },
            "no-backdrop-dismiss": "",
            "no-esc-dismiss": ""
          },
          model: {
            value: _vm.show_modal,
            callback: function($$v) {
              _vm.show_modal = $$v
            },
            expression: "show_modal"
          }
        },
        [
          _c(
            "q-modal-layout",
            [
              _c(
                "q-toolbar",
                {
                  style: { display: _vm.display },
                  attrs: { slot: "header" },
                  slot: "header"
                },
                [
                  _vm.type !== "block_general_test" &&
                  _vm.type !== "restart_general_test"
                    ? _c("q-btn", {
                        attrs: {
                          flat: "",
                          round: "",
                          dense: "",
                          icon: "fas fa-times"
                        },
                        on: {
                          click: function($event) {
                            return _vm.shouldHideModal()
                          }
                        }
                      })
                    : _vm._e(),
                  _c("q-toolbar-title", [
                    _vm._v(
                      "\n                    " +
                        _vm._s(_vm.title) +
                        "\n                "
                    )
                  ])
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "layout-padding" },
                [
                  _vm.in_live_class
                    ? _c("live-class", {
                        key: _vm.id,
                        attrs: {
                          activity: _vm.activity,
                          presential_event_id: _vm.id_course,
                          event_date_id: _vm.event_dates[_vm.event_tab].id,
                          closing: _vm.closing
                        },
                        on: { closeModal: _vm.closeModal }
                      })
                    : _vm._e(),
                  _vm.in_webcast
                    ? _c("webcast", {
                        key: _vm.id,
                        attrs: {
                          activity: _vm.activity,
                          presential_event_id: _vm.id_course,
                          event_date_id: _vm.event_dates[_vm.event_tab].id,
                          closing: _vm.closing
                        },
                        on: { closeModal: _vm.closeModal }
                      })
                    : _vm._e(),
                  _vm.type == "restart_test" ||
                  _vm.type == "block_test" ||
                  _vm.type == "conventional_test" ||
                  _vm.type == "evaluated_quiz" ||
                  _vm.type == "unevaluated_quiz"
                    ? _c("course-test", {
                        key: _vm.id,
                        attrs: {
                          activity: _vm.activity,
                          event_id: _vm.event_dates[_vm.event_tab].id,
                          closing: _vm.closing
                        },
                        on: {
                          clearTest: function($event) {
                            return _vm.closeModal()
                          }
                        }
                      })
                    : _vm._e(),
                  _vm.type === "block_general_test" ||
                  _vm.type === "restart_general_test"
                    ? _c("course-general-test", {
                        key: _vm.id,
                        attrs: {
                          activity: _vm.activity,
                          event_id: _vm.event_dates[_vm.event_tab].id
                        },
                        on: { closeTest: _vm.closeModal }
                      })
                    : _vm._e()
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }